import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"

import { PersonalSourcesPanel } from "../components/personal-sources-panel"

/** Settings → Personal sources. Consent returns here so the user sees the result. */
export function PersonalSourcesPage() {
  const { t } = useTranslation()
  return (
    <main className="mx-auto max-w-2xl space-y-6 p-6">
      <h1 className="type-lead">
        {t("personalSources.title", { defaultValue: "Personal sources" })}
      </h1>
      <PersonalSourcesPanel />
      <Button asChild variant="outline">
        <Link data-testid="personal-sources-return" to="/">
          {t("personalSources.back", { defaultValue: "Back to Hello AI" })}
        </Link>
      </Button>
    </main>
  )
}
